import React, { useCallback } from "react";

import Form from "antd/es/form";
import Popover from "antd/es/popover";
import cn from "classnames";
import { useIntl } from "react-intl";

import Trend from "@app/component/Trend";
import activitiesLoggedCard from "@app/scene/dashboard/components/cards/ActivitiesLogged/index";
import dragStyles from "@app/scene/dashboard/components/styles/common.module.scss";
import Scoped from "@app/scene/dashboard/types/Scoped";
import { DefaultDateRangeConfiguration } from "@app/types/dashboard/CardConfiguration";
import CustomerFaceTimeCardConfiguration from "@app/types/dashboard/cards/customerFaceTime/CustomerFaceTimeCardConfiguration";

import messages from "../messages";

import styles from "./Title.module.scss";

interface Props extends Scoped {
  customTitle?: string;
  dateRange: DefaultDateRangeConfiguration;
  editable?: boolean;
  onChangeConfiguration?: (configuration: Partial<CustomerFaceTimeCardConfiguration>) => void;
  trend?: number;
}

const Title: React.FC<Props> = ({
  customTitle,
  dateRange,
  editable,
  onChangeConfiguration,
  scope,
  trend,
}) => {
  const intl = useIntl();
  const { DateRangeFormComponent } = activitiesLoggedCard;
  const handleValuesChange = useCallback(
    (value) => onChangeConfiguration?.(value),
    [onChangeConfiguration]
  );

  return (
    <>
      {customTitle?.trim() ||
        intl.formatMessage(messages.cardTitle, {
          date: (text: string[]) =>
            editable ? (
              <Popover
                content={
                  <div className={styles.popover}>
                    <Form
                      initialValues={{ dateRange }}
                      layout="vertical"
                      onValuesChange={handleValuesChange}
                    >
                      <DateRangeFormComponent scope={scope} />
                    </Form>
                  </div>
                }
                destroyTooltipOnHide
                placement="bottomLeft"
                showArrow={false}
                trigger={["click"]}
              >
                <div className={cn(styles.range, dragStyles.nonDraggable)}>{text}</div>
              </Popover>
            ) : (
              text
            ),
          dateRange: dateRange.range,
          dateSubRange: dateRange.subRange,
        })}
      <Trend trend={trend} />
    </>
  );
};

export default Title;
